import {useEffect, useState} from "react";

const useDeviceType = () => {
    const [deviceType, setDeviceType] = useState("desktop");

    const getDeviceType = () => {
        const ua = navigator.userAgent.toLowerCase();

        if (/mobile|iphone|ipod|android.*mobile|windows phone|blackberry.*mobile/i.test(ua)) {
            return "mobile";
        } else if (/tablet|ipad|linux|android(?!.*mobile)|playbook|silk/i.test(ua)) {
            return "tablet";
        }
        return "desktop";
    }

    useEffect(() => {
        setDeviceType(getDeviceType());

        const handleResize = () => {
            setDeviceType(getDeviceType());
        }

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return deviceType;
}

export default useDeviceType;
